import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch } from '../../modules/utility';

const runLateAnalysisReport = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `reporting.lateAnalysis.run`,
			params,
			dispatch,
			callback,
		});
	};
};

const runLateAnalysisDetailReport = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `reporting.lateAnalysis.detail.run`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state) => {
	const newState = {};
	newState.userMap = state.maps.user;
	return newState;
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			runLateAnalysisReport,
			runLateAnalysisDetailReport,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
